import { render, staticRenderFns } from "./allGoodsControl.vue?vue&type=template&id=5ede1f12&scoped=true&"
import script from "./allGoodsControl.vue?vue&type=script&lang=js&"
export * from "./allGoodsControl.vue?vue&type=script&lang=js&"
import style0 from "./allGoodsControl.vue?vue&type=style&index=0&id=5ede1f12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede1f12",
  null
  
)

export default component.exports